module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAAAXNSR0IArs4c6QAAAOtJREFUOE+1lDFqAmEQhb8HFjmGB7C0sAx4ABED8RgGLext7GLhIRQSyAUESwvLFDlADiEojDzRSrI7ZNe/2Wb2+9+bN/+Imo9q5qGImAFToFERfgLmBh6Bb2BbEfgMtAwMYCHprQowIt6B0eOBEfEEDJI9XUs62NmfCiOiB3wl7fclXWoLLUdEMwE8Sfq91RUptOVuwrLHZJOx/AqsEgpd8iLps6yHHvA2YKVFxwp3kvwtDMXATsKy091ngB6Zj6TloaR1mcJ6Q0kquyt76NPztvlxg/+r7vqfg2x6OYyBSWJMyu5z6svaN/YZQ1W8xQQ+0gQAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/search_article@2x.png
// module id = WuhA
// module chunks = 1